export function orderBy<T extends object[]>(array: T, key: keyof T[0]) {
  return [...array].sort((a, b) =>
    a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0
  );
}
